import { Component, OnDestroy } from "@angular/core"
import { ApiserviceService } from '../../apiservice.service';
import { CommonfunctionService } from '../../services/commonfunction.service';
import { NotificationService } from '../services/notification.service';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { AdminMenusService } from '../admin-sidebar/admin-menus.service';
import { ViewReportComponent } from './view-report/view-report.component';
import { Router } from '@angular/router';
import { Subscription } from "rxjs";

@Component({
  selector: 'app-sync-property-log',
  templateUrl: './sync-property-log.component.html',
  styleUrls: ['./sync-property-log.component.css']
})
export class SyncPropertyLogComponent implements OnDestroy {
  status: any[] = [
    { status_code: -1, value: 'Invalid' },
    { status_code: 1, value: 'Valid' },
    { status_code: 0, value: 'Started' },
    { status_code: 2, value: 'Accepted' },
    { status_code: -2, value: 'Rejected' },

  ];
  sync_access = {
    'GET': false,
    'POST': false,
    'PATCH': false,
    'DELETE': false
  };
  dataSource = []
  loader = false;
  loader1 = false;
  offset = 0;
  limit = 10;
  totalCount: number;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent: PageEvent;
  private subs = new Subscription();
  //  = ["sno",
  //   "Added Date",
  //   "Existing Count",
  //   "Parameter",
  //   "Process Log",
  //   "Process Name",
  //   "Success Count",
  //   "Target Count",
  //   "UID",
  //   "Updated Date",
  //   "Status",
  //   "Actions"]
  displayedColumns = ["sno",
    "Process Name",
    "Added Date",
    "Updated Date",
    "Existing Count",
    "New Count",
    "Process Log",
    "Status",]

  returnVal(element, cols) {
    switch (cols) {
      case 'Added Date': return this.getdateForm(element.added_date);
      case 'Existing Count': return element.existing_count;
      case 'Process Name': return element.process_name;
      case 'New Count': return element.new_count;
      case 'Target Count': return element.target_count;
      case 'Name': return element.uid;
      case 'Updated Date': return this.getdateForm(element.updated_date);
      case 'Status': return element.status;
    }
  }
  constructor(private readonly api: ApiserviceService,
    private readonly menu: AdminMenusService,
    private readonly fnc: CommonfunctionService,
    private readonly notify: NotificationService,
    public dialog: MatDialog,
    private readonly route: Router) {
    this.menu.setActive('sync-property-log');
    this.getAllowResourcesApi();
  }

  // getting allow resources
  getAllowResourcesApi() {
    let body = `user/resource?place_id=${this.api.city_id}&user_id=${this.api.user_id}`
    const allowResSub = this.api.getUmsData(body)
      .subscribe({next:(res: any) => {
        this.api.allowResources = res.data;
        this.sync_access = this.fnc.checkResourceAccess('calculateSyncProcess', false);
      }, error:err => {
      }
  })
    this.subs.add(allowResSub);
  }
  // getAllowResourcesApi() {
  //   let body = "place_id=" + this.api.city_id;
  //   this.api.postUmsData('user/resource', body)
  //     .subscribe(
  //       (data: any) => {
  //         this.api.allowResources = data;
  //         this.sync_access = this.fnc.checkResourceAccess('calculateSyncProcess', false);
  //       },
  //       err => {
  //       }
  //     )
  // }

  sync(type, uId) {
    if (!this.sync_access.POST) {
      this.notify.notify("You are not authorized to RUN process for Property Attribute Values", "warn",500);
      return;
    }
    this.notify.notify("Request has been submitted to server", 'success',5000);
    let url = `update-property-log`;
    let action;
    let uploadId;
    let body = {
      "action": "validate",
      "isRefresh": true,
      "type": "attribute_value",
      "upload_id": uploadId,
      "user_id": this.api.user_id,
    }
    this.loader = true;
    const syncSub = this.api.postEpsData(url, body).subscribe((res: any) => {
      this.loader = false;
    })
    this.subs.add(syncSub);
  }

  getReports() {
    if (!this.sync_access.GET) {
      this.notify.notify("You are not authorized to GET Report for Sync Process", "warn",5000);
      return;
    }
    let url = `sync-calculate-process?layer=attribute&process_name=attribute_value&sort_asc=false&limit=${this.limit}&offset=${this.offset}`
    this.loader1 = true;
    const reportSub = this.api.getEpsData(url).subscribe((res: any) => {
      this.loader1 = false;
      if (res?.length) {
        this.dataSource = res;
        this.totalCount = res.length;
      }
      else {
        this.notify.notify(res.message, 'success',5000);
      }

    })
    this.subs.add(reportSub);
  }

  getStatus(val) {
    return this.fnc.getArrayValue('status_code', val, this.status).value;
  }

  getdateForm(date: any) {
    if (date) {
      date = new Date(date);
      return this.fnc.formatDateUTC(date);
    }else {
      return '';
    }
  }
  openView(type: any, data: any = null) {
    let _data = null;
    if (type) {
      _data = {
        type: type,
        data: data,
        pdata: this,
      }
    }
    const dialogRef = this.dialog.open(ViewReportComponent, {
      width: "400px",
      panelClass: "view-report",
      data: _data,
    })
    const openSub = dialogRef.afterClosed().subscribe(result => {
    });
    this.subs.add(openSub);
  }


  handlePagination(e) {
    this.limit = e.pageSize;
    if (e.previousPageIndex !== e.pageIndex) {
      this.offset = (e.pageSize * e.pageIndex);
    }
    this.getReports();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
